<template>
    <v-container
        fluid
        class="redeem-treasure-page pa-6">
        <redeem-treasure-view
            :gameId="gameId"/>
    </v-container>
</template>

<script>
import RedeemTreasureView from '@/views/RedeemTreasureView.vue'

export default {
    name: 'RedeemTreasurePage',

    components: {
        RedeemTreasureView
    },

    data () {
        return {
            userId: null,
            gameId: null
        }
    },

    mounted () {
        this.getRedeemRoute()
    },

    methods: {
        getRedeemRoute () {
            const { gameId } = this.$route.params
            this.gameId = gameId
        }
    }
}
</script>

<style lang="scss" scoped>
.redeem-treasure-page {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>
